import { PoliticaDatos } from 'utils/models/interfaces';
import { datosTeatro } from './site';

export const politicaPrivacidadTitulo = 'Politica de privacidad y protección de datos';
export const terminosCondicionesTitulo = 'Términos y Condiciones del Centro Cultural H. Bosch';
export const politicaCookiesTitulo = 'Politica de cookies';

export const politicaPrivacidad: PoliticaDatos[] = [
  {
    titulo: '1. Introducción',
    texto:
      'Bienvenido al sitio web del Centro Cultural H. Bosch. Al acceder y utilizar este sitio, usted acepta los términos de nuestra Política de Privacidad. Si no está de acuerdo con estos términos, por favor no comparta su información personal con nosotros.',
  },
  {
    titulo: '2. Información recopilada',
    texto:
      'El Centro Cultural H. Bosch recopila los siguientes datos personales de sus usuarios: Nombre, Apellido, Correo electrónico, Teléfono (opcional), Fecha de nacimiento (opcional). Estos datos se recopilan con los siguientes fines: 1) Compra de entradas para obras de teatro. 2) Inscripción como socio del teatro. 3) Inscripción a talleres realizados en el teatro. 4) Alquiler de salas del teatro para fines artísticos o de similar entidad.',
  },
  {
    titulo: '3. Uso de la información',
    texto:
      'La información recopilada será utilizada exclusivamente para los fines indicados anteriormente. No compartimos, vendemos ni cedemos sus datos personales a terceros, salvo para el cumplimiento de obligaciones legales o si usted ha dado su consentimiento expreso para ello.',
  },
  {
    titulo: '4. Procesamiento de pagos',
    texto:
      'El Centro Cultural H. Bosch no almacena datos financieros de sus usuarios. Todos los pagos de entradas se realizan a través de una billetera virtual de terceros -Mercado Pago-. Le recomendamos revisar la política de privacidad de Mercado Pago para entender mejor cómo se manejan sus datos financieros: https://www.mercadopago.com.uy/ayuda/terminos-y-politicas_194.',
  },
  {
    titulo: '5. Derechos del usuario',
    texto: `De acuerdo con la Ley N° 18.331 sobre Protección de Datos Personales en Uruguay, usted tiene derecho a: 1) Acceder a los datos personales que hemos recopilado sobre usted. 2) Solicitar la rectificación de sus datos personales si están incorrectos. 3) Solicitar la eliminación de sus datos personales. 4) Oponerse al procesamiento de sus datos personales. Para ejercer cualquiera de estos derechos, puede ponerse en contacto con nosotros a través del correo electrónico ${datosTeatro.email}.`,
  },
  {
    titulo: '6. Seguridad de la información',
    texto:
      'El Centro Cultural H. Bosch se compromete a proteger la seguridad de sus datos personales. Utilizamos medidas de seguridad técnicas y organizativas adecuadas para proteger sus datos contra el acceso no autorizado, la pérdida o la alteración.',
  },
  {
    titulo: '7. Cambios en la Política de Privacidad',
    texto:
      'Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Cualquier cambio será debidamente publicado en esta página, y el uso continuado de nuestro sitio web después de la publicación de cualquier cambio implica su aceptación de la nueva política.',
  },
  {
    titulo: '8. Contacto',
    texto:
      'Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad o sobre nuestras prácticas de manejo de datos personales, no dude en ponerse en contacto con nosotros a través de info@teatrohbosch.uy, a través de nuestro Formulario de Contacto, o visitando nuestro espacio en Gonzalo Ramírez 1826, Montevideo.',
  },
  {
    titulo: '9. Legislación aplicable',
    texto:
      'Esta Política de Privacidad se rige por la legislación vigente en la República Oriental del Uruguay, en particular por la Ley N° 18.331 sobre Protección de Datos Personales: https://www.impo.com.uy/bases/leyes/18331-2008.',
  },
];

export const terminosCondiciones: PoliticaDatos[] = [
  {
    titulo: '1. Introducción',
    texto:
      'Bienvenido al sitio web del Centro Cultural H. Bosch, un espacio cultural fundado en 2011 en el barrio Palermo de Montevideo, bajo la Dirección General de Juan Pablo Moreno. Al acceder y utilizar este sitio, usted acepta estos Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, por favor no utilice nuestro sitio web.',
  },
  {
    titulo: '2. Uso del sitio',
    texto:
      'El sitio web del Centro Cultural H. Bosch está destinado a proporcionar información sobre nuestros servicios, como formación técnica y artística, espectáculos y actividades culturales. Al utilizar nuestro sitio, usted se compromete a utilizarlo de manera responsable y de acuerdo con la ley. Está prohibido el uso del sitio para distribuir contenido ilegal, ofensivo, o que infrinja derechos de terceros.',
  },
  {
    titulo: '3. Información personal',
    texto:
      'Al acceder a ciertos servicios ofrecidos en nuestro sitio, como la inscripción a talleres o compra de entradas, se le solicitará proporcionar datos personales. Estos datos serán utilizados de acuerdo con nuestra Política de Privacidad y conforme a la Ley N° 18.331 sobre Protección de Datos Personales en Uruguay. Usted tiene derecho a acceder, rectificar o eliminar sus datos en cualquier momento.',
  },
  {
    titulo: '4. Compra de entradas y reservas',
    texto:
      'Las compras de entradas para espectáculos se realizan a través de nuestra web online o a través de la plataforma Instagram. Todas las ventas están sujetas a disponibilidad y se reservan los derechos de modificar fechas o cancelar funciones si es necesario. En caso de cancelación, los compradores recibirán un reembolso o podrán optar por una fecha alternativa.',
  },
  {
    titulo: '5. Propiedad intelectual',
    texto:
      'Todos los contenidos presentes en el sitio web del Centro Cultural H. Bosch, incluidos textos, imágenes, logotipos y materiales multimedia, son propiedad del Centro Cultural H. Bosch o de terceros que han autorizado su uso. Queda prohibida la reproducción, distribución o modificación de cualquier contenido sin el consentimiento previo y por escrito de sus respectivos titulares.',
  },
  {
    titulo: '6. Uso del espacio',
    texto:
      'El Centro Cultural H. Bosch se ubica en una casona emblemática de los años 40, concebida como un multi-espacio dinámico para clases, ensayos y espectáculos. El uso del espacio para eventos o actividades debe ser coordinado con nuestro equipo y está sujeto a disponibilidad y cumplimiento de normas de seguridad y convivencia. Cualquier daño causado en las instalaciones será responsabilidad de quien alquile o utilice el espacio.',
  },
  {
    titulo: '7. Modificaciones de los Términos y Condiciones',
    texto:
      'Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Cualquier cambio será publicado en esta página, y el uso continuado del sitio web después de la publicación de dichas modificaciones implica la aceptación de los nuevos términos.',
  },
  {
    titulo: '8. Contacto',
    texto:
      'Si tiene alguna pregunta o inquietud sobre estos Términos y Condiciones, no dude en ponerse en contacto con nosotros a través del correo electrónico info@teatrohbosch.uy, a través de nuestro Formulario de Contacto o visitando nuestro espacio en Gonzalo Ramírez 1826, Montevideo.',
  },
  {
    titulo: '9. Legislación aplicable',
    texto:
      'Estos Términos y Condiciones se rigen por las leyes de la República Oriental del Uruguay, en particular por la Ley N° 18.331 sobre Protección de Datos Personales y cualquier otra normativa aplicable.',
  },
];

export const politicaCookies: PoliticaDatos[] = [
  {
    titulo: '1. ¿Qué son las cookies?',
    texto:
      'Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Estas cookies permiten que el sitio recuerde su actividad y preferencias (como idioma, datos de sesión o compra) durante un período de tiempo, para que no tenga que volver a introducirlas cada vez que regrese al sitio o navegue entre páginas.',
  },
  {
    titulo: '2. Tipos de cookies que utilizamos',
    texto: 'En el sitio web del Centro Cultural H. Bosch, utilizamos los siguientes tipos de cookies:',
  },
  {
    subtitulo: '2.1 Cookies de sesión',
    texto:
      'Estas cookies son temporales y expiran tras un período breve de tiempo. Nos permiten identificarlo durante su visita y asegurarnos de que cualquier información introducida, como la información de sesión o de compra de entradas se mantenga mientras navega entre las páginas del sitio.',
  },
  {
    subtitulo: '2.2 Cookies de compra',
    texto:
      'Estas cookies nos permiten recordar las entradas que ha seleccionado o los datos relacionados con su compra de entradas mientras completa el proceso de pago. Al finalizar la compra o cuando la cookie expira, la información se elimina automáticamente.',
  },
  {
    titulo: '3. Gestión y expiración de cookies',
    texto:
      'Las cookies de sesión y de compra que utilizamos tienen una duración limitada. Las cookies de sesión expiran tras un período de tiempo de dos horas, o después de 15 minutos de inactividad. Las cookies de compra expiran tras un período breve de tiempo o al finalizar la transacción. Usted puede controlar y eliminar las cookies almacenadas en su navegador en cualquier momento a través de la configuración del navegador, sin embargo, si decide desactivar las cookies, es posible que algunas funcionalidades de nuestro sitio no funcionen correctamente.',
  },
  {
    titulo: '4. Consentimiento',
    texto:
      'Al utilizar nuestro sitio web, usted acepta el uso de cookies conforme a esta Política de Cookies. La primera vez que accede al sitio, le solicitamos su consentimiento para el uso de cookies, el cual puede gestionar en cualquier momento a través de la configuración de su navegador.',
  },
  {
    titulo: '5. Cambios en nuestra Política de Cookies',
    texto:
      'Nos reservamos el derecho de modificar esta Política de Cookies en cualquier momento. Cualquier cambio será publicado en esta página, y el uso continuado del sitio después de dichos cambios implica su aceptación de la nueva política.',
  },
  {
    titulo: '6. Contacto',
    texto:
      'Si tiene alguna pregunta sobre nuestra Política de Cookies, puede ponerse en contacto con nosotros a través del correo electrónico teatrobosch.dev@gmail.com.',
  },
];

export const urlMercadoPago = 'https://www.mercadopago.com.uy/ayuda/terminos-y-politicas_194';
export const urlLeyDatosPersonales = 'https://www.impo.com.uy/bases/leyes/18331-2008';

